import React from 'react';
import { Container } from 'react-bootstrap';
import './LoadingPage.css';

const SkeletonCard = () => (
  <div className="sk-card">
    <div className="sk-img sk-pulse" />
    <div className="sk-body">
      <div className="sk-badge sk-pulse" />
      <div className="sk-line sk-line--full sk-pulse" />
      <div className="sk-line sk-line--75 sk-pulse" />
      <div className="sk-meta">
        <div className="sk-chip sk-pulse" />
        <div className="sk-chip sk-pulse" />
      </div>
    </div>
  </div>
);

const LoadingPage = ({ message }) => (
  <Container className="sk-root">
    <div className="sk-header">
      <div className="sk-title sk-pulse" />
      <div className="sk-subtitle sk-pulse" />
    </div>
    <div className="sk-grid">
      {[0, 1, 2, 3, 4, 5].map(i => (
        <SkeletonCard key={i} />
      ))}
    </div>
  </Container>
);

export default LoadingPage;
